import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { searchBfOffers } from "@/lib/bf";

export default function BFOfferPick({ it, i, onPick }) {
  const [q, setQ] = useState(it.raw_code || it.text || "");
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(!!it.fresh);
  useEffect(() => {
    if (!open || q.trim().length < 2) return undefined;
    const t = setTimeout(() => searchBfOffers(q).then(setOpts).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q, open]);
  if (it.options?.length && !open) {
    return (
      <select value="" onChange={(e) => e.target.value === "__s" ? setOpen(true) : onPick(it.options.find((o) => o.key === e.target.value))} data-testid={`bf-fo-opt-${i}`}>
        <option value="">Am găsit {it.options.length} variante, alege produsul…</option>
        {it.options.map((o) => <option key={o.key} value={o.key}>{o.name} ({o.code})</option>)}
        <option value="__s">Caută alt produs…</option>
      </select>
    );
  }
  if (!open) return <button type="button" className="bf-fo-find" onClick={() => setOpen(true)} data-testid={`bf-fo-find-${i}`}><Search size={13} /> Caută produsul</button>;
  return (
    <div className="bf-fo-search">
      <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nume sau cod" data-testid={`bf-fo-search-${i}`} />
      <ul>{opts.map((o) => <li key={o.key}><button type="button" onClick={() => onPick(o)} data-testid={`bf-fo-pick-${i}-${o.code}`}>{o.name} <small>{o.code}</small></button></li>)}</ul>
    </div>
  );
}
